import AbstractItemResource from "../abstract/abstract-item-resource"
import defines from "dpsdk/defines"
const {Resource, ZoneType, ZoneShape, Direction, zoneTypeMeaning} = defines
import AbstractResource from "../abstract/abstract-resource"
import resourceCollection from "../abstract/resource-collection"

export const applyDeviceUpdatedAt = (payload, fallbackDeviceId) => {
    if (!payload) {
        return
    }
    const updatedAt = payload.device_updated_at
    if (updatedAt === undefined || updatedAt === null || updatedAt === '') {
        return
    }
    const deviceId = payload.device_id !== undefined && payload.device_id !== null ? payload.device_id : fallbackDeviceId
    if (deviceId === undefined || deviceId === null) {
        return
    }
    const devices = resourceCollection.getResource(Resource.DEVICES)
    if (!devices) {
        return
    }
    const next = Number(updatedAt)
    if (!Number.isFinite(next)) {
        return
    }
    const item = devices.findById(deviceId) || devices.findById(Number(deviceId))
    if (item) {
        item.updated_at = next
    }
    if (devices.singleItems) {
        const singleItem = devices.singleItems[deviceId] || devices.singleItems[Number(deviceId)]
        if (singleItem) {
            singleItem.updated_at = next
        }
    }
}

class Zone extends AbstractItemResource {
    constructor(data, parent) {
        super(Resource.ZONES, data, parent)
        this.setLabels({
            id: 'ID'
        })
    }

    static typesForDropDown(t) {
        return AbstractResource.defineForDropDown(ZoneType, 'zones', t)
    }

    getShape() {
        if (this.type === ZoneType.ARROW_STOP_LINE_STRAIGHT || this.type === ZoneType.ARROW_STOP_LINE || this.type === ZoneType.STOP_LINE || this.type === ZoneType.DELIMETER || this.type === ZoneType.DOUBLE_DELIMETER) {
            return ZoneShape.LINE
        } else if (this.type === ZoneType.STOP_LIGHT || this.type === ZoneType.ARROW_LIGHT) {
            return ZoneShape.RECT
        }
        return ZoneShape.QUADR
    }

    typeStr(t) {
        return t(`zones.type.${this.type}`)
    }

    directionStr(t) {
        switch (this.direction) {
            case Direction.ONCOMING:
                return t('zones.oncomingDirection')
            case Direction.PASSING:
                return t('zones.passingDirection')
            default:
                return null
        }
    }

    static staticViolationName(type) {
        const code = Zone.staticCodeStr(type)
        return `${code}: ${zoneTypeMeaning[type]}`
    }

    getColor() {
        switch (this.type) {
            case ZoneType.ARROW_LIGHT:
                return '#22CC22'
            case ZoneType.CROSSROAD_GO_STRAIGHT:
            case ZoneType.STOP_LINE:
                return '#CCCC22'
            case ZoneType.CROSSROAD_MUST_TURN:
            case ZoneType.ARROW_STOP_LINE:
            case ZoneType.ARROW_STOP_LINE_STRAIGHT:
                return '#22CC22'
            case ZoneType.DELIMETER:
                return '#BBBBBB'
            case ZoneType.DOUBLE_DELIMETER:
                return '#FFFFFF'
            case ZoneType.LANE:
            case ZoneType.RADAR:
                return '#32BAFF'
            case ZoneType.SIDEWALK:
                return '#964218'
            case ZoneType.SHOULDER:
                return '#BBBBBB'
            case ZoneType.RAILS:
                return '#1A4193'
            case ZoneType.COMMUNAL_LANE:
                return '#FFFFFF'
            case ZoneType.ONE_WAY:
                return '#777777'
            case ZoneType.ZONE_ONCOMING_DRIVE:
                return '#777777'
            case ZoneType.TRUCK:
            case ZoneType.TRUCK_STAT:
            case ZoneType.ILLEGAL_PARKING:
                return '#CC22AA'
            case ZoneType.PLACE_TRASH:
                return '#36c20f'
            case ZoneType.LOW_QUALITY_TRASH_REMOVAL:
            case ZoneType.OUTSIDE_CONTAINER_TRASH:
                return '#24d3c0'
            case ZoneType.BUS:
                return '#000000'
            case ZoneType.INTERVAL_MEASURE:
            case ZoneType.INTERVAL_MEASURE_CAR:
            case ZoneType.INTERVAL_MEASURE_TRUCK:
            case ZoneType.INTERVAL_MEASURE_BUS:
                return '#0000FF'
            case ZoneType.INTEREST:
                return '#FFFFFF'
            default:
                return '#CC2222'
        }
    }

    static staticCodeStr(type) {
        if (zoneTypeMeaning[type]) {
            return zoneTypeMeaning[type]
        }

        return ''
    }

    static getViolationZoneTypes() {
        return [
            ZoneType.LANE,
            ZoneType.RADAR,
            ZoneType.INTERVAL_MEASURE,
            ZoneType.INTERVAL_MEASURE_CAR,
            ZoneType.INTERVAL_MEASURE_TRUCK,
            ZoneType.INTERVAL_MEASURE_BUS,
            ZoneType.SIDEWALK,
            ZoneType.SHOULDER,
            ZoneType.RAILS,
            ZoneType.ZONE_ONCOMING_DRIVE,
            ZoneType.STOP_LINE,
            ZoneType.ARROW_STOP_LINE,
            ZoneType.ARROW_STOP_LINE_STRAIGHT,
            ZoneType.AFTER_STOP_LINE,
            ZoneType.DELIMETER,
            ZoneType.DOUBLE_DELIMETER,
            ZoneType.COMMUNAL_LANE,
            ZoneType.ONE_WAY,
            ZoneType.TRUCK,
            ZoneType.MOVING,
            ZoneType.WAFFLE,
            ZoneType.CROSSWALK_UNCONTROLLED,
            ZoneType.BELT,
            ZoneType.PHONE,
            ZoneType.ILLEGAL_PARKING,
            ZoneType.PLACE_TRASH,
            ZoneType.LOW_QUALITY_TRASH_REMOVAL,
            ZoneType.OUTSIDE_CONTAINER_TRASH,
            ZoneType.HEADLIGHTS_CONTROL,
            ZoneType.CROSSROAD_MUST_TURN,
            ZoneType.CROSSROAD_GO_STRAIGHT
        ]
    }

    static violationsForDropDown(t, empty = '', additional = '', withCode = true) {
        const res = []
        if (empty) {
            res.push({
                label: empty,
                value: null
            })
        }

        if (additional) {
            res.push({
                label: additional,
                value: -1
            })
        }

        Zone.getViolationZoneTypes().forEach(zoneType => {
            res.push({
                label: t(`zones.violation.${zoneType}`),
                value: zoneType
            })
        })

     /*   res.push({
            label: t('Превышение скорости'),
            value: ZoneType.LANE
        })

        res.push({
            label: t('Превышение скорости на участке'),
            value: ZoneType.INTERVAL_MEASURE
        })

        res.push({
            label: t('Превышение скорости на участке (легковые)'),
            value: ZoneType.INTERVAL_MEASURE_CAR
        })

        res.push({
            label: t('Превышение скорости на участке (грузовики)'),
            value: ZoneType.INTERVAL_MEASURE_TRUCK
        })

        res.push({
            label: t('Превышение скорости на участке (автобусы)'),
            value: ZoneType.INTERVAL_MEASURE_BUS
        })

        res.push({
            label: t('Выезд на тротуар'),
            value: ZoneType.SIDEWALK
        })

        res.push({
            label: t('Выезда на обочину'),
            value: ZoneType.SHOULDER
        })

        res.push({
            label: t('Выезд на трамвайные пути'),
            value: ZoneType.RAILS
        })

        res.push({
            label: t('Выезд на встречную полосу движения'),
            value: ZoneType.ZONE_ONCOMING_DRIVE
        })

        res.push({
            label: t('Выезд за стоп линию на ЗСС'),
            value: ZoneType.STOP_LINE
        })

        res.push({
            label: t('Выезд за стоп линию не по стрелке (прямо нельзя)'),
            value: ZoneType.ARROW_STOP_LINE
        })

        res.push({
            label: t('Выезд за стоп линию не по стрелке (прямо можно)'),
            value: ZoneType.ARROW_STOP_LINE_STRAIGHT
        })

        res.push({
            label: t('Проезд перекретска на ЗСС'),
            value: ZoneType.AFTER_STOP_LINE
        })

        res.push({
            label: t('Пересечение сплошной линии'),
            value: ZoneType.DELIMETER
        })

        res.push({
            label: t('Пересечение двойной сплошной линии'),
            value: ZoneType.DOUBLE_DELIMETER
        })

        res.push({
            label: t('Выезд на полосу общественного транспорта'),
            value: ZoneType.COMMUNAL_LANE
        })

        res.push({
            label: t('Встречне движение по дороге с односторонним движением'),
            value: ZoneType.ONE_WAY
        })

        res.push({
            label: t('Движение грузовых автомобилей запрещено'),
            value: ZoneType.TRUCK
        })

        res.push({
            label: t('Перестроение с нарушением ПДД'),
            value: ZoneType.MOVING
        })

        res.push({
            label: t('Выезд на перекресток с затором'),
            value: ZoneType.WAFFLE
        })*/

        if (withCode) {
            return res.map(el => {
                return Zone.staticCodeStr(el.value) ? {label: `${Zone.staticCodeStr(el.value)}: ${el.label}`, value: el.value} : el
            })
        }
        return res
    }

    static violationStr(t, code) {
        const el = Zone.violationsForDropDown(t).find(el => el.value === code)
        if (el) {
            return el.label
        }
        return ''
    }

    codeStr() {
        return Zone.staticCodeStr(this.type)
    }

    static clampCoordinate(value) {
        const number = Math.round(Number(value) || 0)
        if (number < 0) {
            return 0
        }
        return number
    }

    getCoordinates() {
        return {
            x1: Zone.clampCoordinate(this.x1),
            x2: Zone.clampCoordinate(this.x2),
            x3: Zone.clampCoordinate(this.x3),
            x4: Zone.clampCoordinate(this.x4),
            y1: Zone.clampCoordinate(this.y1),
            y2: Zone.clampCoordinate(this.y2),
            y3: Zone.clampCoordinate(this.y3),
            y4: Zone.clampCoordinate(this.y4)
        }
    }

    applyCoordinates(coordinates) {
        const next = coordinates || this.getCoordinates()
        this.x1 = next.x1
        this.x2 = next.x2
        this.x3 = next.x3
        this.x4 = next.x4
        this.y1 = next.y1
        this.y2 = next.y2
        this.y3 = next.y3
        this.y4 = next.y4
        return next
    }

    mergeData(data) {
        if (this.isChanged && data) {
            const coordKeys = ['x1', 'x2', 'x3', 'x4', 'y1', 'y2', 'y3', 'y4']
            const keys = Object.keys(data).filter(key => key !== 'isChanged')
            const coordsOnly = keys.length > 0 && keys.every(key => coordKeys.indexOf(key) >= 0)
            if (!coordsOnly) {
                const next = {...data}
                coordKeys.forEach(key => {
                    delete next[key]
                })
                return super.mergeData(next)
            }
        }
        return super.mergeData(data)
    }

    update(params) {
        const action = super.update(params)
        return (dispatch) => {
            if (this._coordSaveInFlight) {
                return this._coordSaveInFlight.then(() => dispatch(action)).catch(() => dispatch(action))
            }
            return dispatch(action)
        }
    }

    flushCoordinateSave(dispatch) {
        if (this._coordSaveInFlight) {
            this._coordSaveQueued = true
            return this._coordSaveInFlight
        }

        const send = () => {
            const coordinates = this.applyCoordinates()
            this._coordSaveQueued = false
            const parent = this.parent
            this._coordSaveInFlight = parent.apiCallbacks.update(this.id, coordinates)
                .then((data) => {
                    dispatch(parent.updated(data))
                    this._coordSaveInFlight = null
                    if (this._coordSaveQueued) {
                        return send()
                    }
                    this.isChanged = false
                })
                .catch((err) => {
                    this._coordSaveInFlight = null
                    this.isChanged = true
                    parent.handleErrorCodes(err)
                    dispatch({type: `${parent.resourceType}_UPDATE_FAILED`, id: this.id, error: err})
                    throw err
                })
            return this._coordSaveInFlight
        }

        return send()
    }

    saveCoordinates() {
        this.applyCoordinates()
        return (dispatch) => this.flushCoordinateSave(dispatch)
    }

    violationCode() {

    }
}

export default Zone
